import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useRefreshRelatedData } from '@/hooks/useRefreshRelatedData';
import { showApiErrorToast } from '@/utils/errors';
import { updateInstituteType } from '../api/instituteTypes.api';
import type { UpdateInstituteTypePayload } from '../types/instituteType.types';

interface UpdateInstituteTypeArgs {
  id: number;
  payload: UpdateInstituteTypePayload;
}

export function useUpdateInstituteType(onSuccess?: () => void) {
  const refreshRelatedData = useRefreshRelatedData();

  return useMutation({
    mutationFn: ({ id, payload }: UpdateInstituteTypeArgs) => updateInstituteType(id, payload),
    onSuccess: () => {
      void refreshRelatedData('instituteType');
      toast.success('Institute type updated successfully');
      onSuccess?.();
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to update institute type');
    },
  });
}
